const convert = (value: number, factor: number, rounded: boolean = true) => {
  const converted = value * factor

  return rounded ? Math.round(converted) : converted
}

export const milesToKilometers = (mi: number, rounded: boolean = true) => convert(mi, 1.609344, rounded)
